import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'pt-PT';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ijpet5g4t7bv">
      <div lang="pt-PT" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3ml14tc2x3ukl">
        <CountdownBar data-id="element-2" data-mp="3rcj7c4kla37o" />
        <main data-id="element-3" data-mp="3rdaqgfx028h2">
          <Hero data-id="element-4" data-mp="3rdkgu4lyihna" />
          <StatsBar data-id="element-5" data-mp="3rd191gq0t9mz" />
          <Difference data-id="element-6" data-mp="3relwkmdx3sbc" />
          <Recognize data-id="element-7" data-mp="6hp9c27i9cj" />
          <WhatsInside data-id="element-8" data-mp="4wyzymxdckh" />
          <InsidePages data-id="element-9" data-mp="56lvdcob3ly" />
          <Bonuses data-id="element-10" data-mp="2zl39tfhhuw2o" />
          <HowItWorks data-id="element-11" data-mp="2zlle8zeb8glo" />
          <Audience data-id="element-12" data-mp="2zm4xqkjlzd1t" />
          <Offer data-id="element-13" data-mp="2zmwif0bo3qdb" />
          <Guarantee data-id="element-14" data-mp="2zng1ikd20ksx" />
          <Testimonials data-id="element-15" data-mp="33mf1dqjxhrdi" />
          <Faq data-id="element-16" data-mp="33nq5xsl7735o" />
          <FinalCta data-id="element-17" data-mp="33ngiabnml835" />
        </main>
        <Footer data-id="element-18" data-mp="33oi0r16z0wuw" />
      </div>
    </MotionConfig>;
}